import { API } from "aws-amplify";

async function changeEdgeDeviceSite(iotThingName: string, companyId: string, siteId: string): Promise<void> {
  try {
    await API.post(
      'api-service',
      `/devices/reassign/${iotThingName}`,
      {
        body: {
          companyId,
          siteId
        }
      }
    )
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export default changeEdgeDeviceSite;
